import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { PendingObjectiveAssignmentGroupVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrievePendingObjectiveAssignments = createAsyncThunk<
  PendingObjectiveAssignmentGroupVM[],
  void,
  { extra: Partial<Dependencies> }
>("student/studentRetrievePendingObjectiveAssignments", async (_: void, { extra: { studentRepository } }) => {
  return studentRepository!.getPendingObjectiveAssignments();
});
